import i18n from '@/i18n';

export default [
  {
    class: 'current_ranking_url',
    name: 'current_ranking_url',
    width: 347,
    title: i18n.t('top-pages.table.columns.current_ranking_url'),
  },
  {
    class: 'total_keyword_count',
    name: 'total_keyword_count',
    width: 95,
    title: i18n.t('top-pages.table.columns.total_keyword_count'),
  },
  {
    class: 'average_current_rank',
    name: 'average_current_rank',
    width: 136,
    title: i18n.t('top-pages.table.columns.average_current_rank'),
  },
  {
    class: 'total_search_volume',
    name: 'total_search_volume',
    width: 140,
    title: i18n.t('top-pages.table.columns.total_search_volume'),
  },
  {
    class: 'average_cost_per_click',
    name: 'average_cost_per_click',
    width: 131,
    title: i18n.t('top-pages.table.columns.average_cost_per_click'),
  },
];
